export const GraphicPicker = Symbol.for('GraphicPicker');
export const PickerService = Symbol.for('PickerService');

export const BoundsPicker = Symbol.for('BoundsPicker');
export const GlobalPickerService = Symbol.for('GlobalPickerService');
